export const applicationMenus = [
  {
    icon: 'settings',
    title: 'Configurações',
    path: 'form-zisign',
  }
]